<template>
  <div>
    <ul class="settings nav nav-tabs">
      <li class="nav-item">
        <a
          role="button"
          id="aggregations"
          class="settings__aggregations-fields nav-link"
          :class="{ active: selected == 'aggregations' }"
          @click="selectTab($event)"
          >Aggregations Fields</a
        >
      </li>
      <li class="nav-item">
        <a
          role="button"
          id="assets"
          class="settings__assets-fields nav-link"
          :class="{ active: selected == 'assets' }"
          @click="selectTab($event)"
          >Assets Fields</a
        >
      </li>
      <li class="nav-item">
        <a
          role="button"
          id="banner"
          class="settings__banner nav-link"
          :class="{ active: selected == 'banner' }"
          @click="selectTab($event)"
          >Banner</a
        >
      </li>
      <li class="nav-item">
        <a
          role="button"
          id="about"
          class="settings__about nav-link"
          :class="{ active: selected == 'about' }"
          @click="selectTab($event)"
          >About</a
        >
      </li>
    </ul>
    <div class="settings__content row">
      <settings-banner v-if="selected == 'banner'"></settings-banner>
      <settings-about v-else-if="selected == 'about'"></settings-about>
      <settings-fields-table
        v-else
        :dataType="dataType"
        v-on="$listeners"
        :dataElements="dataElements"
      ></settings-fields-table>
    </div>
  </div>
</template>

<script>
import SettingsBanner from '@/components/SettingsBanner.vue'
import SettingsAbout from '@/components/SettingsAbout.vue'
import SettingsFieldsTable from '@/components/SettingsFieldsTable.vue'
export default {
  components: {
    SettingsBanner,
    SettingsFieldsTable,
    SettingsAbout,
  },
  props: {
    dataElements: Object,
  },
  data() {
    return {
      selected: 'aggregations',
      dataType: 'aggregation-fields',
    }
  },
  methods: {
    selectTab(event) {
      this.$emit('clearApiResponse')
      this.selected = event.currentTarget.id
      if (this.selected == 'aggregations') {
        this.dataType = 'aggregation-fields'
      } else if (this.selected == 'assets') {
        this.dataType = 'column-fields'
      }
    },
  },
}
</script>

<style></style>
